"use client";

import { useTranslation } from "@/i18n";
import {
    SectionWrapper,
    SectionEyebrow,
    SectionHeadline,
} from "@/components/ui/SectionWrapper";
import { FadeIn } from "@/components/ui/AnimatedSection";
import { VideoClip } from "@/components/ui/VideoClip";

export function Threats() {
    const { t } = useTranslation();
    return (
        <SectionWrapper className="py-(--section-y-lg)">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
                <FadeIn>
                    <div className="rounded-xl overflow-hidden border border-border bg-surface">
                        <VideoClip
                            src="/media/shot_broken_ship.mp4"
                            alt="Hostile Martian life forms attacking expedition infrastructure"
                            className="w-full h-auto block"
                        />
                    </div>
                </FadeIn>

                <div>
                    <FadeIn delay={0.2}>
                        <SectionEyebrow>{t.threats.eyebrow}</SectionEyebrow>
                        <SectionHeadline>{t.threats.headline}</SectionHeadline>
                        <p className="text-lg text-text-secondary leading-relaxed">
                            {t.threats.description}
                        </p>
                    </FadeIn>
                </div>
            </div>
        </SectionWrapper>
    );
}
